/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_share_facebook_subject20 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `Check out ${i.name} on Graasp`
};

const fr_share_facebook_subject20 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `Découvrez ${i.name} sur Graasp`
};

const de_share_facebook_subject20 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `Schau dir ${i.name} auf Graasp an`
};

const es_share_facebook_subject20 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `Echa un vistazo a ${i.name} en Graasp`
};

const it_share_facebook_subject20 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `Dai un'occhiata a ${i.name} su Graasp`
};

const ar_share_facebook_subject20 = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `شاهد ${i.name} على چراسپ `
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ name: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const share_facebook_subject20 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.share_facebook_subject20(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("share_facebook_subject20", locale)
	if (locale === "en") return en_share_facebook_subject20(inputs)
	if (locale === "fr") return fr_share_facebook_subject20(inputs)
	if (locale === "de") return de_share_facebook_subject20(inputs)
	if (locale === "es") return es_share_facebook_subject20(inputs)
	if (locale === "it") return it_share_facebook_subject20(inputs)
	return ar_share_facebook_subject20(inputs)
};
export { share_facebook_subject20 as "SHARE_FACEBOOK_SUBJECT" }